import { Link } from 'react-router-dom';

type Props = {
  to: string;
  label?: string;
}

export const AddButton = ({ to, label } : Props) => (
  <Link to={to} className="btn">
    <i className="fas fa-plus fa-1x"/>
    <span className="hidden md:flex pl-0.5">
      { label || 'Ajouter' }
    </span>
  </Link>
);
